import { APP_ENV, ENV_LIVE } from './constants';
export const getImageSrc = (filename) => {
    const basePath = APP_ENV === ENV_LIVE
        ? `https://immowelt.de/assets/apps/owpp_marketValueLandingPage/v2/client/public/images/`
        : `https://${APP_ENV}.immowelt.de/assets/apps/owpp_marketValueLandingPage/v2/client/public/images/`;
    return `${basePath}${filename}`;
};
